import { StateCreator } from 'zustand';
import { IFormBuilderEntryFields, IFormBuilderEntrySlice } from './types';
import { formBuilderApi } from '@/API';
import { convertKeys } from '@/utils/common';

const initState: IFormBuilderEntryFields = {
  loadingFormBuilderEntries: false,
  draftFormBuilderEntry: null,
};

export const formBuilderEntrySlice: StateCreator<IFormBuilderEntrySlice> = (
  set,
) => ({
  ...initState,
  setDraftFormBuilderEntry: (draftFormBuilderEntry) =>
    set({ draftFormBuilderEntry }),

  createFormEntry: async (data) => {
    set({ loadingFormBuilderEntries: true });
    try {
      const snakeData = convertKeys(data, 'snake');
      await formBuilderApi.createFormEntry(snakeData);
    } catch (error) {
      console.error('Creating document management entry failed:', error);
      throw error;
    } finally {
      set({ loadingFormBuilderEntries: false });
    }
  },

  patchFormEntry: async (id, body) => {
    try {
      const response = await formBuilderApi.patchFormEntry(id, body);
      set({ draftFormBuilderEntry: convertKeys(response.data.data) });
    } catch (error) {
      console.error('Updating document management entry failed:', error);
      throw error;
    }
  },

  patchFormEntrySignature: async (id, body) => {
    try {
      const response = await formBuilderApi.patchFormEntrySignature(id, body);
      set({ draftFormBuilderEntry: convertKeys(response.data.data) });
    } catch (error) {
      console.error('Updating document management entry failed:', error);
      throw error;
    }
  },

  deleteFormEntry: async (id) => {
    set({ loadingFormBuilderEntries: true });
    try {
      await formBuilderApi.deleteFormEntry(id);
    } catch (error) {
      console.error('Deleting document management entry failed:', error);
      throw error;
    } finally {
      set({ loadingFormBuilderEntries: false });
    }
  },

  signFormEntry: async (id, signature) => {
    set({ loadingFormBuilderEntries: true });
    try {
      await formBuilderApi.signFormEntry(id, { signature });
    } catch (error) {
      console.error('Signing document management entry failed:', error);
      throw error;
    } finally {
      set({ loadingFormBuilderEntries: false });
    }
  },
});
